<ng-container *transloco="let t">
    <button
        tuiIconButton
        type="button"
        class="tui-space_right-3 tui-space_bottom-3 download-button"
        icon="tuiIconDownload"
        (click)="downloadQRCode()"
        size="s"
        appearance="momo"
    ></button>
    <div class="row">
        <div class="col-12">
            <h2 class="mt-2">{{ t('scan_QR_code_to_pay') }}</h2>
            <p class="text-center">{{ t('scan_QR_code_to_pay_description') }}</p>
            @if ([PaymentType.ACB, PaymentType.Eximbank].includes(paymentType())) {
                <img [src]="qrcodeStr()" alt="QR Code" class="flex justify-center w-full" />
            } @else {
                <qrcode [qrdata]="qrcodeStr()" [width]="width" [errorCorrectionLevel]="'M'" class="flex justify-center" #qrcodeCanvas>
                </qrcode>
            }
        </div>
        <div class="col-12 text-center">
            <p>
                <b>{{ t('amount') }}:</b>
                <strong> {{ amount() | formatCurrency }} </strong>
            </p>
            <p>
                <b>{{ t('content') }}:</b>
                {{ description() }}
            </p>
            @if(infoBank()?.beneficiary_name) {
                <p>
                    <b>{{ t('beneficiary_name') }}:</b>
                    {{ infoBank().beneficiary_name }}
                </p>
            } 
            @if(infoBank()?.beneficiary_number) {
                <p>
                    <b>{{ t('beneficiary_number') }}:</b>
                    {{ infoBank().beneficiary_number }}
                </p>
            }
        </div>
        <div class="col-12 mt-4 flex gap-2">
            <div class="w-1/2">
                <button (click)="openDiaLogConfirm(templateConfirm)"
                    tuiButton
                    type="button"
                    appearance="secondary"
                    size="m"
                    class="w-full">
                    {{ t('cancel_v2') }}
                </button>
            </div>
            <div class="w-1/2">
                <button (click)="checkTransaction()"
                    tuiButton
                    type="button"
                    appearance="primary"
                    size="m"
                    [showLoader]="loading() || false"
                    class="w-full">
                    {{ t('check') }}
                </button>
            </div>
        </div>
    </div>
    <ng-template
        #templateConfirm
        let-observer
    >
        <div class="col-12 mt-4 flex gap-2 justify-end">
            <button
                size="m"
                tuiButton
                type="button"
                (click)="observer.complete()"
            >
                {{ t('no') }}
            </button>
            <button
                size="m"
                tuiButton
                type="button"
                class="tui-space_right-3"
                (click)="cancel();observer.complete()"
            >
                {{ t('ok') }}
            </button>
        </div>
    </ng-template>
</ng-container>
